import React from 'react';

import { PLAYER_MARKER_ID } from 'config/testID';

import { EpgProgram, RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';

import {
    EventParentalControlRating,
    VodEditorial,
} from 'services/data-manager/types';

import { UseRecordingsHookReturnType } from 'utils/hooks/useRecordings';

import ContentMarkerIcons from 'components/ContentMarkerIcons';
import Marker from 'components/Marker';

import styles from './styles';

type Props = {
    startTime?: number;
    endTime?: number;
    parentalRating?: EventParentalControlRating;
    program?: RBProgram | EpgProgram | VodEditorial | RecordingItem;
    startoverButtonVisible: boolean;
    isCatchup?: boolean;
    backgroundColor?: string;
    isContentLocked: boolean;
    recordingItem?: UseRecordingsHookReturnType['recordingItem'];
    collectionSuspensionActive: boolean;
};

function TopOverlayMarkers({
    startTime,
    endTime,
    parentalRating,
    program,
    isCatchup,
    startoverButtonVisible,
    backgroundColor,
    isContentLocked,
    recordingItem,
    collectionSuspensionActive,
}: Props) {
    return (
        <>
            {!!(startTime && endTime) && (
                <Marker
                    style={styles.marker}
                    startTime={startTime}
                    endTime={endTime}
                    bgColor={backgroundColor}
                    testID={PLAYER_MARKER_ID}
                />
            )}
            {!!parentalRating && !!program && (
                <ContentMarkerIcons
                    shouldDisplayCatchup={!!isCatchup}
                    parentalRating={parentalRating}
                    iconStyle={styles.markerIcons}
                    shouldDisplayStartOver={
                        startoverButtonVisible && !isCatchup
                    }
                    isContentLocked={isContentLocked}
                    recordingItem={recordingItem}
                    collectionSuspensionActive={collectionSuspensionActive}
                />
            )}
        </>
    );
}

export default TopOverlayMarkers;
